import type { DataAccessRequestStatus } from '@repo/api-codegen';
import type { IconNames } from '@repo/foundations';
import type { ColorNames } from '@repo/theme/utils';

export const StatusColorMap: Record<
	DataAccessRequestStatus,
	{
		iconName: IconNames;
		iconColor?: ColorNames;
		iconFillColor?: ColorNames;
		label: string;
	}
> = {
	deleted: {
		iconName: 'circleXFilled',
		iconFillColor: 'icon/primary/disabled',
		label: 'Closed',
	},
	pending: {
		iconName: 'clock',
		iconColor: 'icon/info/default',
		label: 'Open',
	},
	approved: {
		iconName: 'circleCheckFilled',
		iconFillColor: 'icon/success/default',
		label: 'Active',
	},
	rejected: {
		iconName: 'circleXFilled',
		iconFillColor: 'icon/primary/disabled',
		label: 'Denied',
	},
	expired: {
		iconName: 'circleXFilled',
		iconFillColor: 'icon/primary/disabled',
		label: 'Closed',
	},
	cancelled: {
		iconName: 'circleXFilled',
		iconFillColor: 'icon/primary/disabled',
		label: 'Closed',
	},
};
